import React, { useState } from "react"
import { useTheme } from "@emotion/react"
import { SwitchTextStyles } from "./SwitchTextStyles"
import { styles } from "../../resources/styles/Styles"
import { useSelector } from "react-redux"
import { MocUserRole } from "core/services/models/Enums"

function SwitchText(props: React.PropsWithChildren<ISwitchTextProps>) {
    const theme = useTheme()
    const globalStyles = styles(theme)
    const classes = SwitchTextStyles(theme)


    const userRole = useSelector((state: any) => state?.user?.role)

    const { title, status, lostofollowup, onToggle } =
        props


    return (
        <div >
            <div className={`${classes.switchTextWrapper} cursor-pointer`}
                onClick={() => onToggle(!status)}>
                <div
                    className={`${globalStyles.alignItemsCenter} d-flex ${classes.fullHeight}`}
                >
                    {status ? (
                        <img
                            src={"../../assets/images/switchGreenCircle.svg"}
                            alt="switchGreenCircle"
                            width="24px"
                            height="24px"
                        />
                    ) : (
                        <img
                            src={"../../assets/images/switchRedCircle.svg"}
                            alt="switchRedCircle"
                            width="24px"
                            height="24px"
                        />
                    )}
                    <div className={classes.title}>{title}</div>
                </div>
            </div>
        </div>
    )
}

export default SwitchText

interface ISwitchTextProps {
    title?: any
    status?: boolean
    onToggle?: any
    lostofollowup?: any
}
